/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ImpersonateRouteImport } from './routes/impersonate'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PublicUpdatePasswordRouteImport } from './routes/_public/update-password'
import { Route as PublicResetPasswordRouteImport } from './routes/_public/reset-password'
import { Route as PublicRegisterRouteImport } from './routes/_public/register'
import { Route as PublicLogoutRouteImport } from './routes/_public/logout'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicEmailVerificationRouteImport } from './routes/_public/email-verification'
import { Route as PublicCheckEmailRouteImport } from './routes/_public/check-email'
import { Route as PublicAccountPasswordRouteImport } from './routes/_public/account-password'
import { Route as AuthedSettingsRouteImport } from './routes/_authed/settings'
import { Route as AuthedPortalRouteImport } from './routes/_authed/portal'
import { Route as AuthedOrderKitsRouteImport } from './routes/_authed/order-kits'
import { Route as PublicDebugMonitoringRouteImport } from './routes/_public/debug.monitoring'
import { Route as AuthedOrderKitsSuccessRouteImport } from './routes/_authed/order-kits.success'
import { Route as AuthedOrderKitsStoreRouteImport } from './routes/_authed/order-kits.store'
import { Route as AuthedOrderKitsPatientPayRouteImport } from './routes/_authed/order-kits.patient-pay'
import { Route as PublicMayoclinicStorePractitionerIdRouteImport } from './routes/_public/mayoclinic.store.$practitionerId'

const ImpersonateRoute = ImpersonateRouteImport.update({
  id: '/impersonate',
  path: '/impersonate',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicUpdatePasswordRoute = PublicUpdatePasswordRouteImport.update({
  id: '/update-password',
  path: '/update-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicResetPasswordRoute = PublicResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicRegisterRoute = PublicRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLogoutRoute = PublicLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const PublicEmailVerificationRoute = PublicEmailVerificationRouteImport.update({
  id: '/email-verification',
  path: '/email-verification',
  getParentRoute: () => PublicRoute,
} as any)
const PublicCheckEmailRoute = PublicCheckEmailRouteImport.update({
  id: '/check-email',
  path: '/check-email',
  getParentRoute: () => PublicRoute,
} as any)
const PublicAccountPasswordRoute = PublicAccountPasswordRouteImport.update({
  id: '/account-password',
  path: '/account-password',
  getParentRoute: () => PublicRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPortalRoute = AuthedPortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOrderKitsRoute = AuthedOrderKitsRouteImport.update({
  id: '/order-kits',
  path: '/order-kits',
  getParentRoute: () => AuthedRoute,
} as any)
const PublicDebugMonitoringRoute = PublicDebugMonitoringRouteImport.update({
  id: '/debug/monitoring',
  path: '/debug/monitoring',
  getParentRoute: () => PublicRoute,
} as any)
const AuthedOrderKitsSuccessRoute = AuthedOrderKitsSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => AuthedOrderKitsRoute,
} as any)
const AuthedOrderKitsStoreRoute = AuthedOrderKitsStoreRouteImport.update({
  id: '/store',
  path: '/store',
  getParentRoute: () => AuthedOrderKitsRoute,
} as any)
const AuthedOrderKitsPatientPayRoute =
  AuthedOrderKitsPatientPayRouteImport.update({
    id: '/patient-pay',
    path: '/patient-pay',
    getParentRoute: () => AuthedOrderKitsRoute,
  } as any)
const PublicMayoclinicStorePractitionerIdRoute =
  PublicMayoclinicStorePractitionerIdRouteImport.update({
    id: '/mayoclinic/store/$practitionerId',
    path: '/mayoclinic/store/$practitionerId',
    getParentRoute: () => PublicRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/impersonate': typeof ImpersonateRoute
  '/order-kits': typeof AuthedOrderKitsRouteWithChildren
  '/portal': typeof AuthedPortalRoute
  '/settings': typeof AuthedSettingsRoute
  '/account-password': typeof PublicAccountPasswordRoute
  '/check-email': typeof PublicCheckEmailRoute
  '/email-verification': typeof PublicEmailVerificationRoute
  '/login': typeof PublicLoginRoute
  '/logout': typeof PublicLogoutRoute
  '/register': typeof PublicRegisterRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/update-password': typeof PublicUpdatePasswordRoute
  '/order-kits/patient-pay': typeof AuthedOrderKitsPatientPayRoute
  '/order-kits/store': typeof AuthedOrderKitsStoreRoute
  '/order-kits/success': typeof AuthedOrderKitsSuccessRoute
  '/debug/monitoring': typeof PublicDebugMonitoringRoute
  '/mayoclinic/store/$practitionerId': typeof PublicMayoclinicStorePractitionerIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/impersonate': typeof ImpersonateRoute
  '/order-kits': typeof AuthedOrderKitsRouteWithChildren
  '/portal': typeof AuthedPortalRoute
  '/settings': typeof AuthedSettingsRoute
  '/account-password': typeof PublicAccountPasswordRoute
  '/check-email': typeof PublicCheckEmailRoute
  '/email-verification': typeof PublicEmailVerificationRoute
  '/login': typeof PublicLoginRoute
  '/logout': typeof PublicLogoutRoute
  '/register': typeof PublicRegisterRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/update-password': typeof PublicUpdatePasswordRoute
  '/order-kits/patient-pay': typeof AuthedOrderKitsPatientPayRoute
  '/order-kits/store': typeof AuthedOrderKitsStoreRoute
  '/order-kits/success': typeof AuthedOrderKitsSuccessRoute
  '/debug/monitoring': typeof PublicDebugMonitoringRoute
  '/mayoclinic/store/$practitionerId': typeof PublicMayoclinicStorePractitionerIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/impersonate': typeof ImpersonateRoute
  '/_authed/order-kits': typeof AuthedOrderKitsRouteWithChildren
  '/_authed/portal': typeof AuthedPortalRoute
  '/_authed/settings': typeof AuthedSettingsRoute
  '/_public/account-password': typeof PublicAccountPasswordRoute
  '/_public/check-email': typeof PublicCheckEmailRoute
  '/_public/email-verification': typeof PublicEmailVerificationRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/logout': typeof PublicLogoutRoute
  '/_public/register': typeof PublicRegisterRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/_public/update-password': typeof PublicUpdatePasswordRoute
  '/_authed/order-kits/patient-pay': typeof AuthedOrderKitsPatientPayRoute
  '/_authed/order-kits/store': typeof AuthedOrderKitsStoreRoute
  '/_authed/order-kits/success': typeof AuthedOrderKitsSuccessRoute
  '/_public/debug/monitoring': typeof PublicDebugMonitoringRoute
  '/_public/mayoclinic/store/$practitionerId': typeof PublicMayoclinicStorePractitionerIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/impersonate'
    | '/order-kits'
    | '/portal'
    | '/settings'
    | '/account-password'
    | '/check-email'
    | '/email-verification'
    | '/login'
    | '/logout'
    | '/register'
    | '/reset-password'
    | '/update-password'
    | '/order-kits/patient-pay'
    | '/order-kits/store'
    | '/order-kits/success'
    | '/debug/monitoring'
    | '/mayoclinic/store/$practitionerId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/impersonate'
    | '/order-kits'
    | '/portal'
    | '/settings'
    | '/account-password'
    | '/check-email'
    | '/email-verification'
    | '/login'
    | '/logout'
    | '/register'
    | '/reset-password'
    | '/update-password'
    | '/order-kits/patient-pay'
    | '/order-kits/store'
    | '/order-kits/success'
    | '/debug/monitoring'
    | '/mayoclinic/store/$practitionerId'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/_public'
    | '/impersonate'
    | '/_authed/order-kits'
    | '/_authed/portal'
    | '/_authed/settings'
    | '/_public/account-password'
    | '/_public/check-email'
    | '/_public/email-verification'
    | '/_public/login'
    | '/_public/logout'
    | '/_public/register'
    | '/_public/reset-password'
    | '/_public/update-password'
    | '/_authed/order-kits/patient-pay'
    | '/_authed/order-kits/store'
    | '/_authed/order-kits/success'
    | '/_public/debug/monitoring'
    | '/_public/mayoclinic/store/$practitionerId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  ImpersonateRoute: typeof ImpersonateRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/impersonate': {
      id: '/impersonate'
      path: '/impersonate'
      fullPath: '/impersonate'
      preLoaderRoute: typeof ImpersonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/update-password': {
      id: '/_public/update-password'
      path: '/update-password'
      fullPath: '/update-password'
      preLoaderRoute: typeof PublicUpdatePasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/register': {
      id: '/_public/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof PublicRegisterRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/logout': {
      id: '/_public/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof PublicLogoutRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/email-verification': {
      id: '/_public/email-verification'
      path: '/email-verification'
      fullPath: '/email-verification'
      preLoaderRoute: typeof PublicEmailVerificationRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/check-email': {
      id: '/_public/check-email'
      path: '/check-email'
      fullPath: '/check-email'
      preLoaderRoute: typeof PublicCheckEmailRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/account-password': {
      id: '/_public/account-password'
      path: '/account-password'
      fullPath: '/account-password'
      preLoaderRoute: typeof PublicAccountPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/portal': {
      id: '/_authed/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof AuthedPortalRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/order-kits': {
      id: '/_authed/order-kits'
      path: '/order-kits'
      fullPath: '/order-kits'
      preLoaderRoute: typeof AuthedOrderKitsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_public/debug/monitoring': {
      id: '/_public/debug/monitoring'
      path: '/debug/monitoring'
      fullPath: '/debug/monitoring'
      preLoaderRoute: typeof PublicDebugMonitoringRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authed/order-kits/success': {
      id: '/_authed/order-kits/success'
      path: '/success'
      fullPath: '/order-kits/success'
      preLoaderRoute: typeof AuthedOrderKitsSuccessRouteImport
      parentRoute: typeof AuthedOrderKitsRoute
    }
    '/_authed/order-kits/store': {
      id: '/_authed/order-kits/store'
      path: '/store'
      fullPath: '/order-kits/store'
      preLoaderRoute: typeof AuthedOrderKitsStoreRouteImport
      parentRoute: typeof AuthedOrderKitsRoute
    }
    '/_authed/order-kits/patient-pay': {
      id: '/_authed/order-kits/patient-pay'
      path: '/patient-pay'
      fullPath: '/order-kits/patient-pay'
      preLoaderRoute: typeof AuthedOrderKitsPatientPayRouteImport
      parentRoute: typeof AuthedOrderKitsRoute
    }
    '/_public/mayoclinic/store/$practitionerId': {
      id: '/_public/mayoclinic/store/$practitionerId'
      path: '/mayoclinic/store/$practitionerId'
      fullPath: '/mayoclinic/store/$practitionerId'
      preLoaderRoute: typeof PublicMayoclinicStorePractitionerIdRouteImport
      parentRoute: typeof PublicRoute
    }
  }
}

interface AuthedOrderKitsRouteChildren {
  AuthedOrderKitsPatientPayRoute: typeof AuthedOrderKitsPatientPayRoute
  AuthedOrderKitsStoreRoute: typeof AuthedOrderKitsStoreRoute
  AuthedOrderKitsSuccessRoute: typeof AuthedOrderKitsSuccessRoute
}

const AuthedOrderKitsRouteChildren: AuthedOrderKitsRouteChildren = {
  AuthedOrderKitsPatientPayRoute: AuthedOrderKitsPatientPayRoute,
  AuthedOrderKitsStoreRoute: AuthedOrderKitsStoreRoute,
  AuthedOrderKitsSuccessRoute: AuthedOrderKitsSuccessRoute,
}

const AuthedOrderKitsRouteWithChildren = AuthedOrderKitsRoute._addFileChildren(
  AuthedOrderKitsRouteChildren,
)

interface AuthedRouteChildren {
  AuthedOrderKitsRoute: typeof AuthedOrderKitsRouteWithChildren
  AuthedPortalRoute: typeof AuthedPortalRoute
  AuthedSettingsRoute: typeof AuthedSettingsRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedOrderKitsRoute: AuthedOrderKitsRouteWithChildren,
  AuthedPortalRoute: AuthedPortalRoute,
  AuthedSettingsRoute: AuthedSettingsRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface PublicRouteChildren {
  PublicAccountPasswordRoute: typeof PublicAccountPasswordRoute
  PublicCheckEmailRoute: typeof PublicCheckEmailRoute
  PublicEmailVerificationRoute: typeof PublicEmailVerificationRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicLogoutRoute: typeof PublicLogoutRoute
  PublicRegisterRoute: typeof PublicRegisterRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
  PublicUpdatePasswordRoute: typeof PublicUpdatePasswordRoute
  PublicDebugMonitoringRoute: typeof PublicDebugMonitoringRoute
  PublicMayoclinicStorePractitionerIdRoute: typeof PublicMayoclinicStorePractitionerIdRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicAccountPasswordRoute: PublicAccountPasswordRoute,
  PublicCheckEmailRoute: PublicCheckEmailRoute,
  PublicEmailVerificationRoute: PublicEmailVerificationRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicLogoutRoute: PublicLogoutRoute,
  PublicRegisterRoute: PublicRegisterRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
  PublicUpdatePasswordRoute: PublicUpdatePasswordRoute,
  PublicDebugMonitoringRoute: PublicDebugMonitoringRoute,
  PublicMayoclinicStorePractitionerIdRoute:
    PublicMayoclinicStorePractitionerIdRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  ImpersonateRoute: ImpersonateRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
